import o from "./index201.js";
/* empty css         */
import t from "./index130.js";
const m = /* @__PURE__ */ t(o, [["__scopeId", "data-v-cb20f6ea"]]);
export {
  m as default
};
